type GuideStep = {
  number: string;
  title: string;
  description: string;
  image?: string;
  alt?: string;
};

const guideSteps: GuideStep[] = [
  {
    number: "01",
    title: "Kaggleプロフィールを開く",
    description:
      "Kaggleプロフィール画面で「Edit your public profile」を押します。",
    image: "/assets/images/howToRegister/howToRegister1.png",
    alt: "Kaggleプロフィール画面のEdit your public profileボタン",
  },
  {
    number: "02",
    title: "Bioの編集ボタンを押す",
    description: "プロフィール編集画面で、Bio欄の鉛筆アイコンを選択します。",
    image: "/assets/images/howToRegister/howToRegister2.png",
    alt: "Kaggleプロフィール編集画面のBio編集ボタン",
  },
  {
    number: "03",
    title: "認証キーを入力して保存する",
    description:
      "発行された認証キーをBio欄に追加し、Saveを押して変更を保存します。",
    image: "/assets/images/howToRegister/howToRegister3.png",
    alt: "KaggleのBio欄にAIYSS認証キーを入力してSaveする画面",
  },
  {
    number: "04",
    title: "AIYSSに戻って確認する",
    description:
      "Bioを保存したらこのページに戻り、下の確認ボタンを押して登録を完了します。",
  },
];

type KaggleBioGuideProps = {
  profileUrl: string;
  onVerify: () => void;
  isChecking: boolean;
  message?: string;
};

export function KaggleBioGuide({
  profileUrl,
  onVerify,
  isChecking,
  message,
}: KaggleBioGuideProps) {
  return (
    <section className="bio-guide" aria-labelledby="bio-guide-title">
      <div className="bio-guide-heading">
        <p className="league-eyebrow">HOW TO ADD BIO</p>
        <h3 id="bio-guide-title">KaggleのBioに認証キーを追加する手順</h3>
        <p>画像の順番に沿って操作し、最後に確認ボタンを押してください。</p>
      </div>
      <ol className="bio-guide-list">
        {guideSteps.map((step) => (
          <li className="bio-guide-step" key={step.number}>
            <span className="bio-guide-number">{step.number}</span>
            <div className="bio-guide-content">
              <h4>{step.title}</h4>
              <p>{step.description}</p>
              {step.number === "01" && (
                <a
                  className="bio-guide-link"
                  href={profileUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  プロフィールを開く ↗
                </a>
              )}
              {step.image ? (
                <img
                  className="bio-guide-image"
                  src={step.image}
                  alt={step.alt}
                  loading="lazy"
                />
              ) : (
                <>
                  <button
                    className="league-primary-link register-button bio-guide-action"
                    type="button"
                    onClick={onVerify}
                    disabled={isChecking}
                  >
                    {isChecking ? "確認中…" : "Bioを確認して登録を完了する"}
                    <span aria-hidden="true">→</span>
                  </button>
                  {message && (
                    <p
                      className="register-status is-error bio-guide-action-status"
                      role="alert"
                    >
                      {message}
                    </p>
                  )}
                </>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
